module.exports = __webpack_public_path__ + "img/icon-passport-color.6b65720b.png";